const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                    initSwipeIndicators();
                  }
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();
                    }
                    initSwipeIndicators();
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

// Builds the swipe track entirely in JS on mobile so the desktop DOM and all
// existing CSS hover selectors are never touched.
const initSwipeIndicators = () => {
  if (!window.matchMedia('(max-width: 989px)').matches) return;

  document.querySelectorAll('.media.media--hover-effect').forEach(mediaEl => {
    // Tear down any prior initialisation so this function is safe to re-run
    // (e.g. after a colour swatch change updates the images).
    const existingTrack = mediaEl.querySelector('.media__swipe-track');
    if (existingTrack) {
      clearTimeout(existingTrack._resetTimer);
      Array.from(existingTrack.querySelectorAll('img')).forEach(img => mediaEl.insertBefore(img, existingTrack));
      existingTrack.remove();
    }
    const existingDots = mediaEl.querySelector('.media__swipe-dots');
    if (existingDots) existingDots.remove();

    const primaryImage = mediaEl.querySelector('.media--first');
    const secondaryImage = mediaEl.querySelector('.media--second');
    if (!primaryImage || !secondaryImage) return;

    // Wrap both images in the scroll snap track
    const track = document.createElement('div');
    track.className = 'media__swipe-track';
    mediaEl.insertBefore(track, primaryImage);
    track.appendChild(primaryImage);
    track.appendChild(secondaryImage);

    // Inject dot indicators
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'media__swipe-dots';
    [0, 1].forEach(i => {
      const dot = document.createElement('span');
      dot.className = 'media__swipe-dot' + (i === 0 ? ' is-active' : '');
      dotsContainer.appendChild(dot);
    });
    mediaEl.appendChild(dotsContainer);

    track.addEventListener('scroll', () => {
      const activeIndex = Math.round(track.scrollLeft / track.offsetWidth);
      dotsContainer.querySelectorAll('.media__swipe-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }, { passive: true });

    const resetDelayMs = (parseInt(mediaEl.dataset.swipeResetDelay, 10) || 5) * 1000;
    // After the snap settles, start a timer to scroll back to the primary image.
    // If the user swipes back manually first, cancel the timer.
    // Uses scroll + debounce instead of scrollend for Safari compatibility.
    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const activeIndex = Math.round(track.scrollLeft / track.offsetWidth);
        if (activeIndex === 1) {
          track._resetTimer = setTimeout(() => {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollTo({ left: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
          }, resetDelayMs);
        } else {
          clearTimeout(track._resetTimer);
        }
      }, 150);
    }, { passive: true });

    // The track sits above the overlay link (z-index: 2 vs 1), so taps on the image
    // area would be swallowed. Forward them to the overlay link to preserve navigation.
    track.addEventListener('click', () => {
      const overlayLink = mediaEl.closest('.card-wrapper')?.querySelector('.card-wrapper__link--overlay');
      if (overlayLink?.href) window.location.href = overlayLink.href;
    });
  });
};

function colorSwatches() {
  checkSwatches();
  initSwipeIndicators();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
    initSwipeIndicators();
  });
}

(function () {
colorSwatches();
})()
